import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { cn } from "@/core/helpers/cn";
import { Icon } from "@/shared/ui";
import { NotificationQuestErrorState } from "@/domains/notification/constants/notificationState";

type Props = { className?: string } & NotificationQuestErrorState;

export default function NotificationQuestError({ className, questName, rewards }: Props) {
  const { t } = useTranslation("notification");

  return (
    <div className={cn("flex flex-col items-center z-1", className)}>
      <motion.div
        initial={{ opacity: 0, translateY: "-100%" }}
        animate={{ opacity: 1, translateY: "none" }}
        exit={{ opacity: 0, translateY: "-100%", transition: { type: "spring", durataion: 0.3 } }}
        transition={{
          type: "spring",
          delay: 0.1,
          duration: 0.3,
        }}
        className="flex items-center gap-2.5 mt-5.5"
      >
        <Icon category="notification" name="error" className="w-[2rem] h-[1.75rem] bg-[#FF4E4E]" />
        <div className="text-20 font-bold text-[#FF4E4E] whitespace-nowrap">
          {t("notification.questNotCompleted")}
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, translateY: "100%" }}
        animate={{ opacity: 1, translateY: "none" }}
        exit={{ opacity: 0, translateY: "100%", transition: { type: "spring", durataion: 0.3 } }}
        transition={{
          type: "spring",
          duration: 0.3,
          delay: 0.4,
        }}
        className="mt-3"
      >
        <div className="text-18 text-white font-bold text-center">{questName}</div>
        <div className="text-15 text-[#FF4E4E] font-medium text-center">
          {t("notification.rewardsForPerfomance")}
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, translateY: "100%" }}
        animate={{ opacity: 1, translateY: "none" }}
        exit={{ opacity: 0, translateY: "100%", transition: { type: "spring", durataion: 0.3 } }}
        transition={{
          type: "spring",
          duration: 0.3,
          delay: 0.7,
        }}
        className="text-18 text-[#FF4E4E] font-bold mt-3.5"
      >
        {rewards} ₽
      </motion.div>
    </div>
  );
}
